import classNames from 'classnames';
import * as React from 'react';
const Label = (props) => {
    const { children, className, hasError = false, layout = 'vertical', ...rest } = props;
    const wrapperClasses = classNames('ixu-form-element', className, {
        'ixu-form-element--horizontal': layout === 'horizontal' || layout === 'horizontal-inversed',
    });
    const labelClasses = classNames('ixu-form-element__label', {
        'is-error': hasError,
    });
    const childrenArray = React.Children.toArray(children);
    const input = childrenArray[childrenArray.length - 1];
    const content = [
        React.createElement("div", { className: labelClasses, key: "label" }, childrenArray.slice(0, -1)),
        input,
    ];
    if (layout === 'vertical-inversed' || layout === 'horizontal-inversed') {
        content.reverse();
    }
    return (React.createElement("label", { className: wrapperClasses, ...rest },
        content[0],
        content[1]));
};
export default Label;
//# sourceMappingURL=Label.js.map